export default{formGroup:"w_AU",formGroupLegend:"w_AV",formGroupRow:"w_AW",label:"w_AX",helperTextContainer:"w_AY"};
